import React, {
    useContext,
    useEffect,
    useState,
} from 'react';
import { ThemeContext } from '@src/index';
import {
    BackgroundContainer,
    Blob,
    GradientOverlay,
    MobileBackground,
    MobileBlob,
} from './styled';

const AnimatedBackground = () => {
    const palette = useContext(ThemeContext);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () =>
            window.removeEventListener(
                'resize',
                checkMobile
            );
    }, []);

    if (isMobile) {
        return (
            <BackgroundContainer
                $PRIMARY_BG_COLOR={palette.PRIMARY_BG_COLOR}
            >
                <MobileBackground>
                    <MobileBlob
                        $color={`radial-gradient(circle at 30% 30%, ${palette.BLOB_COLOR_1} 0%, transparent 60%),
                                 radial-gradient(circle at 70% 70%, ${palette.BLOB_COLOR_2} 0%, transparent 60%)`}
                    />
                </MobileBackground>
                <GradientOverlay
                    $OVERLAY_COLOR={palette.OVERLAY_COLOR}
                />
            </BackgroundContainer>
        );
    }

    return (
        <BackgroundContainer
            $PRIMARY_BG_COLOR={palette.PRIMARY_BG_COLOR}
        >
            <Blob
                color={`radial-gradient(circle, ${palette.BLOB_COLOR_1} 0%, rgba(123, 31, 162, 0) 70%)`}
                top="30%"
                left="20%"
                duration="25s"
            />
            <Blob
                color={`radial-gradient(circle, ${palette.BLOB_COLOR_2} 0%, rgba(0, 188, 212, 0) 70%)`}
                top="70%"
                left="80%"
                duration="30s"
            />
            <Blob
                color={`radial-gradient(circle, ${palette.BLOB_COLOR_3} 0%, rgba(255, 64, 129, 0) 70%)`}
                top="50%"
                left="50%"
                duration="40s"
            />
            <GradientOverlay
                $OVERLAY_COLOR={palette.OVERLAY_COLOR}
            />
        </BackgroundContainer>
    );
};

export default AnimatedBackground;
